import React from "react";

import {
  Card,
  CardContent,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";

import { SelectField } from "react-admin";

import { useUser } from "../../../authenticatorApp/UserContext";
import { carrierMembershipKey } from "../../../utils/carrierUserUtils";
import { UserStatuses } from "../../../utils/constants";
import { UserStatusIcon } from "../../../managerApp/resources/users/UserStatusIcon";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up("sm")]: {
      width: "16em",
      minWidth: "16em",
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(0.5),
      overflow: "initial",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  statusIcon: {
    marginTop: theme.spacing(-0.3),
  },
}));

export const CarrierAside = ({ backPath, record, ...props }) => {
  const classes = useStyles();
  const { appUser } = useUser();

  // A block is held per membership — one carrier at one transload — and the one
  // worth reporting is the membership this portal is signed in for. The same
  // person can hold a second junction at this yard under another carrier, so
  // the yard alone could pick that row and report the other carrier's block.
  // Access elsewhere is another membership's business; the list ranks by the
  // same key, so the icon here agrees with the one on their line.
  const sessionKey = carrierMembershipKey({
    reloadYardId: appUser?.reloadYardId,
    carrierId: appUser?.carrierId,
  });
  const junction = record?.reloadYardCarriers?.items?.find(
    (item) => carrierMembershipKey(item) === sessionKey,
  );

  if (!record) return null;
  return (
    <Card className={classes.root}>
      <CardContent>
        <Grid container direction="column" spacing={1}>
          <Grid item xs={12}>
            <Typography variant="overline" color="textSecondary">
              Status:
            </Typography>
            <Grid container direction="row">
              <Grid item xs={2}>
                <UserStatusIcon
                  record={record}
                  blocked={junction?.blockAccess}
                  classes={classes.statusIcon}
                />
              </Grid>
              <Grid item xs={10} className={classes.status}>
                <SelectField
                  source="status"
                  record={record}
                  choices={UserStatuses}
                />
              </Grid>
            </Grid>
          </Grid>
          {record.driverCode && (
            <Grid item xs={12}>
              <Typography variant="overline" color="textSecondary">
                Driver Code:
              </Typography>
              <Typography variant="body2">{record.driverCode}</Typography>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};
